import { render, staticRenderFns } from "./programtvgrp.vue?vue&type=template&id=5f331908"
import script from "./programtvgrp.vue?vue&type=script&lang=js"
export * from "./programtvgrp.vue?vue&type=script&lang=js"
import style0 from "./programtvgrp.vue?vue&type=style&index=0&id=5f331908&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports